export const SORT_PARAM = "sort";
export const METRIC_PARAM = "metric";
export const INCLUDE_PARAM = "include";
export const ORDERBY_PARAM = "orderby";
export const TAG_SET_PARAM = "tag_set";
export const VIEW_ID_PARAM = "view";
export const EXPAND_PARAM = "expand";
export const TAB_PARAM = "tab";
export const DECK_PARAM = "deck";
export const TAB_PARAM_ON_DECK = "deck_tab";
export const LAYOUT_PARAM = "layout";
